import { useCurrentDistributionContentQuery } from "@/features/experience-shared/composables/useCurrentDistributionContentQuery";
import { useCurrentRawExperienceQuery } from "@/features/experience-raw/composables/useCurrentRawExperienceQuery";
import { useCurrentExperienceTranslationsQuery } from "@/features/experience-curation/queries/useExperienceTranslationsQuery";
import { useCurrentRawSnapshotsQuery } from "@/features/experience-curation/queries/useRawSnapshotsQuery";
import { useCurrentExperienceRawFunctionalsQuery } from "@/features/experience-curation/queries/useExperienceRawFunctionalsQuery";
import { useCurrentBookingInformationQuery } from "@/features/experience-curation/queries/useBookingInformationQuery";
import { useCurrentExperienceCategoriesInterestsQuery } from "@/features/experience-curation/queries/useExperienceCategoriesInterestsQuery";
import { useCurrentTranslationDiffSnapshotsQuery } from "@/features/experience-curation/queries/useTranslationDiffSnapshotsQuery";
import { useCurrentExperienceLocationQuery } from "@/features/experience-shared/queries/useExperienceLocationQuery";
import { useCurrentExperienceVenuesQuery } from "@/features/experience-shared/queries/useExperienceVenuesQuery";
import { useCurrentExperienceAdditionalCitiesQuery } from "@/features/experience-shared/queries/useExperienceAdditionalCitiesQuery";
import { useCurrentExperienceOptionNamesQuery } from "@/features/experience-shared/queries/useExperienceOptionNamesQuery";
import { useCurrentExperienceOptionsQuery } from "@/features/experience-shared/queries/useExperienceOptionsQuery";

export function useCurationQueries() {
  return [
    useCurrentDistributionContentQuery(),
    useCurrentRawExperienceQuery(),
    useCurrentExperienceTranslationsQuery(),
    useCurrentRawSnapshotsQuery(),
    useCurrentExperienceRawFunctionalsQuery(),
    useCurrentBookingInformationQuery(),
    useCurrentExperienceCategoriesInterestsQuery(),
    useCurrentTranslationDiffSnapshotsQuery(),
    useCurrentExperienceLocationQuery(),
    useCurrentExperienceVenuesQuery(),
    useCurrentExperienceAdditionalCitiesQuery(),
    useCurrentExperienceOptionNamesQuery(),
    useCurrentExperienceOptionsQuery(),
  ];
}
